export default __webpack_public_path__ + "static/press-release-mefa-secondary-5b46af1badc21b070d1c582f53c578fc.png";